import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectsOwnershipTransferComponent } from '../../../../../../../shared/components/projects-ownership-transfer/projects-ownership-transfer.component';
import { ProjectService } from '../../../../../../../shared/services/project.service';
import { OwnershipTransferTypes } from '../../../../../../../shared/interfaces';
import { PermissionService } from '../../../../../../../shared/services/permissions.service';
import { AuthService } from '../../../../../../../shared/services/auth.service';
import { canTransferProjectManager } from '../../../../../../../shared/utils/permission-checks';

@Component({
  templateUrl: './transfer-project-rights-cell.component.html',
  styleUrl: './transfer-project-rights-cell.component.scss',
  standalone: false,
})
export class TransferWorkspaceProjectsRightsCellComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  canTransfer: boolean = false;
  canTransferManager: boolean = false;

  constructor(
    private readonly modalService: NgbModal,
    private readonly projectService: ProjectService,
    private readonly permissionService: PermissionService,
    private readonly authService: AuthService
  ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.checkOwnership();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.checkOwnership();
    return true;
  }

  checkOwnership() {
    this.canTransfer = false;
    this.canTransferManager = canTransferProjectManager(
      this.permissionService,
      this.projectService.project,
      this.params.data.username,
      this.authService.getAuthUserName()
    );
  }

  transfer() {
    const modalRef = this.modalService.open(ProjectsOwnershipTransferComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.sourceUser = this.params.data;
    modalRef.componentInstance.projects = [this.params.context.componentParent.selectedProject];
    modalRef.componentInstance.transferType = OwnershipTransferTypes.PROJECT;
    modalRef.componentInstance.isProjectManagerTransfer = this.canTransferManager;
    modalRef.result.then((result: boolean) => {
      if (!result) {
        return;
      }

      this.params.context.componentParent.loadParticipants(this.params.context.componentParent.selectedProject);
    });
  }
}
